import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Wrench, CheckCircle2, ArrowRight, Car, User, Package, CircleDollarSign, Calendar } from 'lucide-react';
import { PricingCards } from '../components/landing/PricingCards';
import { Footer } from '../components/landing/Footer';
export function Landing() {
  return <div className="min-h-screen bg-background flex flex-col" data-id="element-580">
      <header className="container mx-auto px-4 sm:px-6 h-16 sm:h-20 flex items-center justify-between border-b border-border/40" data-id="element-581">
        <div className="flex items-center gap-2" data-id="element-582">
          <div className="bg-primary p-2 rounded-xl" data-id="element-583">
            <Wrench className="h-5 w-5 sm:h-6 sm:w-6 text-primary-foreground" data-id="element-584" />
          </div>
          <span className="font-heading font-bold text-lg sm:text-xl tracking-tight" data-id="element-585">
            GarageFlow
          </span>
        </div>
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-muted-foreground" data-id="element-586">
          <a href="#features" className="hover:text-foreground transition-colors" data-id="element-587">
            Recursos
          </a>
          <a href="#pricing" className="hover:text-foreground transition-colors" data-id="element-588">
            Preços
          </a>
          <Link to="/login" className="hover:text-foreground transition-colors" data-id="element-589">
            Entrar
          </Link>
          <Button asChild data-id="element-590">
            <Link to="/onboarding" data-id="element-591">Teste Grátis</Link>
          </Button>
        </nav>
        {/* Mobile nav: just the CTA */}
        <div className="md:hidden flex items-center gap-2" data-id="element-592">
          <Link to="/login" className="text-sm font-medium text-muted-foreground hover:text-foreground" data-id="element-593">
            Entrar
          </Link>
          <Button size="sm" asChild data-id="element-594">
            <Link to="/onboarding" data-id="element-595">Testar grátis</Link>
          </Button>
        </div>
      </header>

      <main className="flex-1" data-id="element-596">
        <section className="container mx-auto px-4 sm:px-6 py-16 sm:py-24 md:py-32 flex flex-col items-center text-center" data-id="element-597">
          <div className="inline-flex items-center rounded-full border border-primary/20 bg-primary/10 px-3 py-1 text-sm font-medium text-primary mb-8" data-id="element-598">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2" data-id="element-599"></span>O
            ERP definitivo para oficinas
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-heading font-bold tracking-tight max-w-4xl mb-6" data-id="element-600">
            Gestão <span className="text-primary" data-id="element-601">inteligente</span> para sua
            oficina mecânica
          </h1>
          <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mb-10" data-id="element-602">
            Abandone as planilhas e o papel. Controle ordens de serviço,
            estoque, financeiro e agendamentos em uma plataforma moderna e
            rápida.
          </p>
          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-603">
            <Button size="lg" className="h-14 px-8 text-base sm:text-lg w-full sm:w-auto" asChild data-id="element-604">
              <Link to="/onboarding" data-id="element-605">
                Começar agora <ArrowRight className="ml-2 h-5 w-5" data-id="element-606" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" className="h-14 px-8 text-base sm:text-lg w-full sm:w-auto" data-id="element-607">
              Falar com vendas
            </Button>
          </div>

          <div className="mt-12 sm:mt-20 w-full max-w-5xl rounded-2xl border border-border/50 bg-card/50 p-2 shadow-2xl backdrop-blur-sm" data-id="element-608">
            <div className="rounded-xl overflow-hidden border border-border bg-background aspect-video flex items-center justify-center text-muted-foreground text-sm sm:text-base" data-id="element-609">
              [Screenshot do Dashboard do GarageFlow]
            </div>
          </div>
        </section>

        <section className="border-y border-border bg-muted/30 py-10" data-id="element-610">
          <div className="container mx-auto px-4 sm:px-6 text-center" data-id="element-611">
            <p className="text-sm font-medium text-muted-foreground mb-6" data-id="element-612">
              Mais de 500 oficinas confiam no GarageFlow
            </p>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-8 md:gap-16 opacity-60" data-id="element-613">
              {['AutoCenter SP', 'Mecânica do João', 'Garage Premium', 'Turbo Motors', 'Oficina Central', 'Performance Auto'].map((logo, i) => <span key={i} className="text-sm sm:text-lg font-heading font-bold uppercase tracking-wider text-muted-foreground" data-id="element-614">
                  {logo}
                </span>)}
            </div>
          </div>
        </section>

        <section id="features" className="py-16 sm:py-24 bg-background" data-id="element-615">
          <div className="container mx-auto px-4 sm:px-6" data-id="element-616">
            <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-617">
              <h2 className="text-3xl md:text-4xl font-heading font-bold tracking-tight mb-4" data-id="element-618">
                Tudo que sua oficina precisa em um só lugar
              </h2>
              <p className="text-lg text-muted-foreground" data-id="element-619">
                Uma plataforma completa desenhada especificamente para o fluxo
                de trabalho de oficinas mecânicas modernas.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-620">
              {[{
              icon: Wrench,
              title: 'Ordens de Serviço',
              desc: 'Kanban visual com drag-and-drop, timeline de status e checklist completo'
            }, {
              icon: Car,
              title: 'Histórico do Veículo',
              desc: 'Saúde do veículo, alertas inteligentes e histórico de manutenção em um clique'
            }, {
              icon: User,
              title: 'Gestão de Clientes',
              desc: 'Cadastro completo, histórico de serviços e integração com WhatsApp'
            }, {
              icon: Package,
              title: 'Controle de Estoque',
              desc: 'Alertas de estoque mínimo, controle de fornecedores e custos automatizados'
            }, {
              icon: CircleDollarSign,
              title: 'Financeiro Integrado',
              desc: 'Fluxo de caixa, contas a receber e relatórios em tempo real'
            }, {
              icon: Calendar,
              title: 'Agenda Online',
              desc: 'Agendamentos com confirmação automática e lembrete por WhatsApp'
            }].map((feature, i) => <div key={i} className="rounded-2xl border border-border p-6 bg-card hover:border-primary/40 transition-colors" data-id="element-621">
                  <div className="h-12 w-12 rounded-xl bg-primary/10 flex items-center justify-center mb-6" data-id="element-622">
                    <feature.icon className="h-6 w-6 text-primary" data-id="element-623" />
                  </div>
                  <h3 className="text-xl font-semibold mb-2" data-id="element-624">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed" data-id="element-625">
                    {feature.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        <section id="pricing" className="py-16 sm:py-24 bg-muted/30 border-y border-border" data-id="element-626">
          <div className="container mx-auto px-4 sm:px-6" data-id="element-627">
            <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16" data-id="element-628">
              <h2 className="text-3xl md:text-4xl font-heading font-bold tracking-tight mb-4" data-id="element-629">
                Preço justo, sem surpresas
              </h2>
              <p className="text-lg text-muted-foreground" data-id="element-630">
                14 dias grátis. Cancele quando quiser. Sem cartão de crédito.
              </p>
            </div>
            <PricingCards ctaLabel="Começar grátis" onSelect={() => window.location.href = '/onboarding'} data-id="element-631" />
          </div>
        </section>

        <section className="py-16 sm:py-24 bg-primary/10 border-y border-primary/20" data-id="element-632">
          <div className="container mx-auto px-4 sm:px-6 text-center" data-id="element-633">
            <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-bold tracking-tight mb-6" data-id="element-634">
              Pronto para modernizar sua oficina?
            </h2>
            <p className="text-base sm:text-xl text-muted-foreground max-w-2xl mx-auto mb-10" data-id="element-635">
              Junte-se a mais de 500 oficinas que já economizam horas por semana
              com o GarageFlow.
            </p>
            <Button size="lg" className="h-14 px-8 sm:px-10 text-base sm:text-lg" asChild data-id="element-636">
              <Link to="/onboarding" data-id="element-637">Começar 14 dias grátis</Link>
            </Button>
          </div>
        </section>
      </main>
      <Footer data-id="element-638" />
    </div>;
}